import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { useState, useRef } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import roundSpeed from '@iconify/icons-ic/round-speed';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import roundStreetview from '@iconify/icons-ic/round-streetview';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, List, Link, Button, AppBar, Hidden, Toolbar, MenuItem, Container, ListItemIcon, ListItemText, } from '@material-ui/core';
import { UtilsLib } from '@payface-frontends-libs/utils';
import { Logo, MenuPopover } from '../../generics';
import { MIconButton } from '../../@material-extend';
const { useOffSetTop } = UtilsLib.Hooks;
const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 96;
const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    '& .isDesktopActive': {
        color: `${theme.palette.primary.main} !important`,
    },
    '& .isMobileActive': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium,
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    },
}));
const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    height: APP_BAR_MOBILE,
    transition: theme.transitions.create(['height', 'background-color'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shorter,
    }),
    [theme.breakpoints.up('md')]: { height: APP_BAR_DESKTOP },
}));
const ToolbarShadowStyle = styled('div')(({ theme }) => ({
    left: 0,
    right: 0,
    bottom: 0,
    height: 24,
    zIndex: -1,
    margin: 'auto',
    borderRadius: '50%',
    position: 'absolute',
    width: `calc(100% - 48px)`,
    boxShadow: theme.customShadows.z8,
}));
export function HomeNavbar({ homePath }) {
    const anchorRef = useRef(null);
    const { pathname } = useLocation();
    const offset = useOffSetTop(100);
    const [openMenu, setOpenMenu] = useState(false);
    const isHome = pathname === '/';
    const MENU_LINKS = [
        { title: 'Home', icon: homeFill, href: '/' },
        { title: 'Components', icon: roundStreetview, href: homePath.components },
        { title: 'Dashboard', icon: roundSpeed, href: homePath.dashboard },
    ];
    const renderMenuDesktop = (_jsx(_Fragment, { children: MENU_LINKS.map((link) => (_jsx(Link, Object.assign({ exact: true, to: link.href, underline: "none", variant: "subtitle2", component: RouterLink, activeClassName: "isDesktopActive", sx: {
                mr: 5,
                color: 'text.primary',
                transition: (theme) => theme.transitions.create('opacity', {
                    duration: theme.transitions.duration.shortest,
                }),
                '&:hover': { opacity: 0.48 },
                ...(isHome && { color: 'common.white' }),
                ...(offset && { color: 'text.primary' }),
            } }, { children: link.title }), link.title))) }, void 0));
    const renderMenuMobile = (_jsx(MenuPopover, Object.assign({ disablePortal: true, open: openMenu, anchorEl: anchorRef.current, onClose: () => setOpenMenu(false) }, { children: _jsx(List, { children: MENU_LINKS.map((link) => (_jsxs(MenuItem, Object.assign({ exact: true, to: link.href, component: RouterLink, onClick: () => setOpenMenu(false), activeClassName: "isMobileActive", sx: { color: 'text.secondary', py: 1 } }, { children: [_jsx(ListItemIcon, { children: _jsx(Icon, { icon: link.icon, width: 20, height: 20 }, void 0) }, void 0), _jsx(ListItemText, Object.assign({ primaryTypographyProps: { typography: 'body2' } }, { children: link.title }), void 0)] }), link.title))) }, void 0) }), void 0));
    return (_jsxs(RootStyle, Object.assign({ color: "transparent" }, { children: [_jsx(ToolbarStyle, Object.assign({ disableGutters: true, sx: {
                    ...(offset && {
                        bgcolor: 'background.default',
                        height: { md: APP_BAR_DESKTOP - 20 },
                    }),
                } }, { children: _jsxs(Container, Object.assign({ maxWidth: "lg", sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    } }, { children: [_jsx(RouterLink, Object.assign({ to: "/" }, { children: _jsx(Logo, {}, void 0) }), void 0), _jsx(Box, { sx: { flexGrow: 1 } }, void 0), _jsx(Hidden, Object.assign({ mdDown: true }, { children: renderMenuDesktop }), void 0), _jsx(Button, Object.assign({ underline: "none", variant: "contained", component: Link, target: "_blank", href: homePath.purchase }, { children: "Purchase Now" }), void 0), _jsxs(Hidden, Object.assign({ mdUp: true }, { children: [_jsx(MIconButton, Object.assign({ ref: anchorRef, onClick: () => setOpenMenu(true), sx: {
                                        ml: 1,
                                        ...(isHome && { color: 'common.white' }),
                                        ...(offset && { color: 'text.primary' }),
                                    } }, { children: _jsx(Icon, { icon: menu2Fill }, void 0) }), void 0), renderMenuMobile] }), void 0)] }), void 0) }), void 0), offset && _jsx(ToolbarShadowStyle, {}, void 0)] }), void 0));
}
//# sourceMappingURL=HomeNavbar.js.map